export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7664.82582811.jpg";